export default {
  name: "Footer",

  data() {
    return {
      links: [],
      footer: ''
    };
  },

  created() {
    this.getBaseSet();
  },

  methods: {
    async getBaseSet() {
      const res = await this.$http.getBaseSet();
      this.footer = res.copyright;
    }

  }
};